import "ol/ol.css";
import { responseMsg } from "../../common/ResponseMsg";
import { useEffect, useState, useContext, useRef } from "react";
import { Map as OlMap, View, Feature } from "ol";
import { OSM } from "ol/source";
import { fromLonLat, transform, get as getProj } from 'ol/proj';
import { Tile as TileLayer, Vector as  VectorLayer } from 'ol/layer'; // 지도타일

import { Control, defaults as defaultControls } from 'ol/control';

// 마커
import { Point } from "ol/geom";
import { Style, Icon } from "ol/style";
import ico_point from "../../../assets/img/map/point.svg";
import { Vector as VectorSource } from "ol/source";
import Flex from "../../../shared/components/Flex";
import Input from "../../../shared/components/Input";
import useDevice from "../../../shared/hooks/useDevice";
import ManageButton from "../../../shared/components/ManageButton";
import Radio from "../../../shared/components/Radio";
import Label from "../../../shared/components/Label";

// 검색 유틸 컨트롤러
class SearchControl extends Control {
    constructor(opiton) {

        super({
            element: opiton.ref.current,
        });
    }
}

function Map(props) {
    const [ mapObject, setMapObject ] = useState({}); // 맵 객체
    const { viewData, clickEvent } = props;
    const [markerData, setMarkerData] = useState();
    const [markerLayer, setMarkerLayer] = useState({});

    const [searchText, setSearchText] = useState('');
    const [searchAddressType,setSearchAddressType] = useState('road');
    const searchRef = useRef(); 
    const device = useDevice();
    const isMobile = device !== "desktop";

    const getXY = () => {

        fetch('/api/system/sensors/geo-search',{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({address:searchText,addressType:searchAddressType}),
        })
        .then((res) => res.json())
        .then((json) => {
            if (json.code === responseMsg.SUCCESS.code) {
                const x = json.data.lon
                const y = json.data.lat
                clickEvent([x,y]);
                setMarkerData({x: x, y: y})

                mapObject.map.setView(new View({
                    projection: getProj('EPSG:3857'),
                    center: fromLonLat([x, y], getProj('EPSG:3857')),
                    zoom: mapObject.map.getView().getZoom(),
                }))
            } else if (json.code === responseMsg.FAIL.code) {
                alert("통신이 지연되고 있습니다..");
            }
        })
        .catch(error => {
        });
    }

    useEffect(() => {
        const map = new OlMap({
            controls: defaultControls(),
            layers: [
                new TileLayer({
                    source: new OSM(),
                    name: "OSM",
                })
            ],
            target: "map",
            view: new View({
                projection: getProj('EPSG:3857'),
                center: fromLonLat(viewData === null ? [126.75, 37.47] : [viewData.x, viewData.y], getProj('EPSG:3857')),
                zoom: 15
            })
        });

        map.on('click',  handleMapClick);
        setMarkerData(viewData);
        setMapObject({ map });
    }, []);

    const handleMapClick = (e) => {
        const clickedCoordinate = e.coordinate;
        const transformCoordinate = transform(clickedCoordinate, 'EPSG:3857', 'EPSG:4326');

        if(clickEvent) {
            clickEvent(transformCoordinate);
            setMarkerData({x: transformCoordinate[0], y: transformCoordinate[1]})
        }
    }

    useEffect(() => {
        if(mapObject.map) {
            if(markerData) {
                mapObject.map.removeLayer(markerLayer);

                const iconFeature = new Feature({
                    geometry: new Point(fromLonLat([markerData.x, markerData.y], getProj("EPSG:3857"))),
                    name: null,
                    population: 4000,
                    rainfall: 500,
                });

                const iconStyle = new Style({
                    image: new Icon({
                        anchor: [0.5, 36],
                        anchorXUnits: "fraction",
                        anchorYUnits: "pixels",
                        src: ico_point,
                    }),
                });

                iconFeature.setStyle(iconStyle);

                const marker = new VectorLayer({
                    source: new VectorSource({
                        features: [iconFeature],
                    }),
                });

                mapObject.map.addLayer(marker);
                setMarkerLayer(marker);
            }
        }
    }, [viewData, markerData])

    return (
        <>
            <Flex ref={searchRef} flexDirection={isMobile ? "column" : "row"} style={{marginBottom: "10px"}} gap={20}>
                <Flex gap={16} alignItems="center">
                    <Flex gap={6}>
                        <Radio id="road" name="type" value={"road"} defaultChecked={true} onClick={({target}) => setSearchAddressType(target.value)}></Radio>
                        <Label htmlFor="road">도로명</Label>
                    </Flex>
                    <Flex gap={6}>
                        <Radio id="parcel" name="type" value={"parcel"} onClick={({target}) => setSearchAddressType(target.value)}></Radio>
                        <Label htmlFor="parcel">지번</Label>
                    </Flex>
                </Flex>
                <Flex gap={5} style={{position:"relative", flex: 1}}>
                    <Input placeholder="도로명 또는 지번 주소를 입력해 주세요" aria-label="검색" fullWidth
                        maxLength={100}
                        style={{paddingRight:"70px"}}
                        value={searchText}
                        onChange={({target}) => {
                            setSearchText(target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                const val = e.target.value;
                                if(val.trim() !== ""){
                                    getXY();
                                }
                            }
                        }}/>
                    <ManageButton 
                            onClick={getXY} 
                            btnType='search'
                            style={{display: "flex", alignItems: "center", position: "absolute", right: isMobile ? "3px":"5px", bottom: isMobile ? "3px":"6px"}} 
                        />
                </Flex>
            </Flex>
            <div id="map" data-value={mapObject} style={{height: isMobile ? '350px':'81%', width: '100%', position: ''}}></div>      
        </>
    )
}

export default Map;